import {IconButton, Switch, TableRow} from 'platform/components';
import {HStack, Show, Text} from 'platform/foundation';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {useGetVehicleQuery} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

import {EMPTY_PLACEHOLDER, RequiredTestIdProps, suffixTestId} from 'shared/web';

interface CampaignManuallySelectedVehicleRowProps extends RequiredTestIdProps {
  vehicleId: string;
  isIncluded: boolean;
  onIsIncludedChange: (isIncluded: boolean) => void;
  onRemove: () => void;
}

export function CampaignManuallySelectedVehicleRow(props: CampaignManuallySelectedVehicleRowProps) {
  const {data: vehicle} = useGetVehicleQuery({vehicleId: props.vehicleId});

  const title = vehicle?.title || EMPTY_PLACEHOLDER;
  const registrationPlate = vehicle?.registrationPlate;

  return (
    <TableRow data-testid={props['data-testid']}>
      <HStack align="center" spacing={2}>
        <Text size="small" alternative data-testid={suffixTestId('label', props)}>
          {title}
        </Text>
        <Show when={isNotNilOrEmpty(registrationPlate)}>
          <Text size="xSmall" color="secondary" data-testid={suffixTestId('secondaryLabel', props)}>
            {registrationPlate}
          </Text>
        </Show>
      </HStack>
      <HStack justify="flex-end">
        <Switch
          value={props.isIncluded}
          onChange={props.onIsIncludedChange}
          data-testid={suffixTestId('inCampaign', props)}
        />
      </HStack>
      <HStack justify="flex-end">
        <IconButton
          icon="navigation/close"
          aria-label={i18n.t('general.actions.remove')}
          onClick={props.onRemove}
          data-testid={suffixTestId('remove', props)}
        />
      </HStack>
    </TableRow>
  );
}
